import Vue from 'vue'
import VueRouter from 'vue-router'
//公众号后台路由
import BackLogin from '../views/BackState/BackLogin'   //登录页面
import BackHome from '../views/BackState/BackHome'  //后台首页
import Information from '../views/BackState/InformationSitting'  //推送设置页面
import WelcomeSitting from '../views/BackState/WelcomeSitting'    //欢迎词设置页面
import KeywordsSittings from '../views/BackState/KeywordsSittings'  //关键词设置页面
import KeywordsEdit from '../views/BackState/keywordsEdit'  //关键词设置页面
import keywordsAdd from '../views/BackState/keywordsAdd'    //关键词添加

//H5路由
import Mindex from '../views/H5/M-index'
import Mfocus from '../views/H5/M-focus'
import Mgame from '../views/H5/M-game'


// H5 后台路由
import H5BackLogin from '../views/H5back/H5BackLogin'   //登录页面
import H5BackHome from '../views/H5back/H5BackHome'  //后台首页
import H5Checkandreceive from '../views/H5back/H5Checkandreceive'  //核对领奖页面
import H5Listofawards from '../views/H5back/H5Listofawards'    //获奖名单页面



Vue.use(VueRouter)
  const routes = [
  {
    path: '/',
    name: '/Mindex',
    component: Mindex,
  },
  {
    path: '/BackLogin',
    name: 'BackLogin',
    component: BackLogin,
  },
  {
    path: '/BackHome',
    name: 'BackHome',
    component: resolve=>(require(["@/views/BackState/BackHome"],resolve)),
    children: [
      {
        path: '/Information',
        name: 'Information',
        component: Information,
      },
      {
        path: '/WelcomeSitting',
        name: 'WelcomeSitting',
        component: WelcomeSitting,
      },
      {
        path: '/KeywordsSittings',
        name: 'KeywordsSittings',
        component: KeywordsSittings,
      },
      {
        path: '/KeywordsEdit',
        name: 'KeywordsEdit',
        component: KeywordsEdit
      },
      {
        path: '/keywordsAdd',
        name: 'keywordsAdd',
        component: keywordsAdd
      }
    ]
  },
  {
    path: '/Mindex',
    name: 'Mindex',
    component: Mindex
  },
  {
    path: '/Mfocus',
    name: 'Mfocus',
    component: resolve=>(require(["@/views/H5/M-focus"],resolve))
  },
  {
    path: '/Mgame',
    name: 'Mgame',
    component: resolve=>(require(["@/views/H5/M-game"],resolve))
  },
  {
    path: '/Mrank',
    name: 'Mrank',
    component: resolve=>(require(["@/views/H5/M-rank"],resolve))
  },
  {
    path: '/Maward',
    name: 'Maward',
    component: resolve=>(require(["@/views/H5/M-award"],resolve))
  },
  {
    path: '/Mlist',
    name: 'Mlist',
    component: resolve=>(require(["@/views/H5/M-list"],resolve))
  },
  {
    path: '/Msupport',
    name: 'Msupport',
    component: resolve=>(require(["@/views/H5/M-support"],resolve))
  },
  {
    path: '/H5BackLogin',
    name: 'H5BackLogin',
    component: H5BackLogin
  },
  
  {
    path: '/H5BackHome',
    name: 'H5BackHome',
    component: H5BackHome,
    children: [
      {
        path: '/H5Checkandreceive',
        name: 'H5Checkandreceive',
        component: H5Checkandreceive,
      },
      {
        path: '/H5Listofawards',
        name: 'H5Listofawards',
        component: H5Listofawards,
      },
    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
